import { render, staticRenderFns } from "./InquiryListContainer.vue?vue&type=template&id=46b4696c&scoped=true"
import script from "./InquiryListContainer.vue?vue&type=script&lang=js"
export * from "./InquiryListContainer.vue?vue&type=script&lang=js"
import style0 from "./InquiryListContainer.vue?vue&type=style&index=0&id=46b4696c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4696c",
  null
  
)

export default component.exports